

import React, { Component } from 'react'

const hasOpenInformationAndDetails = WrappedComponent => {

    class HasOpenInformationAndDetails extends Component {
        constructor(props) {
            super(props)

            this.state = {
                activeItem: false,
                activeDetailsItem: false,
                activePerformance: false,
                performancePageOpen: false,
                activeItemIndex: ''
            }

            this.onOpenInformation = this.onOpenInformation.bind(this)
            this.onCloseInformation = this.onCloseInformation.bind(this)
            this.onOpenDetails = this.onOpenDetails.bind(this)
            this.onCloseDetails = this.onCloseDetails.bind(this)
            this.onOpenDetailsFirstSidebar = this.onOpenDetailsFirstSidebar.bind(this)
            this.onCloseDetailsFirstSidebar = this.onCloseDetailsFirstSidebar.bind(this)
            this.onOpenPerformancePage = this.onOpenPerformancePage.bind(this)
            this.onClosePerformancePage = this.onClosePerformancePage.bind(this)
        }

        setSelectionId() {
            if(this.props.setIdForActiveSelection)  {
                this.props.setIdForActiveSelection(this.props.selectionId)
            }
        }

        onOpenInformation({id, index}) {
            const { onSidebarRightOpen } = this.props
    
            this.setSelectionId()
            this.onClosePerformancePage()
    
            onSidebarRightOpen()
            
            this.setState({
                activeItem: id,
                activeDetailsItem: false,
                activeItemIndex: index
            })
        }
    
           
        onCloseInformation() {
            const { onSidebarRightClose } = this.props

            onSidebarRightClose()
            this.setState({
                activeItem: false,
                activeDetailsItem: false
            })
        }

        onClosePerformancePage() {
            const { activeDetailsItem } = this.state
            const { onSidebarRightSecondClose, displaySidebarRight } = this.props

            onSidebarRightSecondClose()

            if(!displaySidebarRight) {
                this.setState({
                    activeItem: false,
                    activeDetailsItem: false
                })
            }

            if(activeDetailsItem) {
                this.setState({
                    activePerformance: false,
                    performancePageOpen: false
                })
            } else {
                this.setState({
                    activePerformance: false,
                    performancePageOpen: false
                })
            }
        }

        onOpenPerformancePage(activePerformance) {
            const {movieIndex} = activePerformance
            const { activeDetailsItem } = this.state
            const { onSidebarRightSecondOpen } = this.props

            this.setSelectionId()

            onSidebarRightSecondOpen()

            if(movieIndex) {
                this.setState({
                    activeItemIndex: movieIndex
                })
            }

            if(activeDetailsItem) {
                this.setState({
                    activePerformance: activePerformance,
                    performancePageOpen: true
                })
            } else {
                this.setState({
                    activeItem: activePerformance.movieId,
                    activePerformance: activePerformance,
                    performancePageOpen: true
                })
            }
        }

        onOpenDetails(itemObj = false, sidebarOpen="onSidebarRightSecondOpen") {
            this.setSelectionId()
            this.props[sidebarOpen]()

            this.setState({
                activeDetailsItem: itemObj && itemObj.hasOwnProperty('movieId') && itemObj.movieId ? itemObj.movieId : true
            })
        }

        onCloseDetails(itemObj, sidebarClose='onSidebarRightSecondClose') {
            this.props[sidebarClose]()
            
            this.setState({
                activeDetailsItem: false
            })
        }

        onOpenDetailsFirstSidebar(itemObj = false) {
            this.onOpenDetails(itemObj, "onSidebarRightOpen")
        }

        onCloseDetailsFirstSidebar(itemObj) {
            this.onCloseDetails(itemObj, 'onSidebarRightClose')
        }


        render() {
            const { activeItem, activeDetailsItem, activePerformance, performancePageOpen, activeItemIndex } = this.state
            const isOpen = activeDetailsItem ? ' is-open' : ''

            const injectedProps = {
                activeItem: activeItem,
                activeDetailsItem: activeDetailsItem,
                activePerformance: activePerformance,
                performancePageOpen: performancePageOpen,
                onCloseDetails: this.onCloseDetails,
                onOpenDetails: this.onOpenDetails,
                onOpenDetailsFirstSidebar: this.onOpenDetailsFirstSidebar,
                onCloseDetailsFirstSidebar: this.onCloseDetailsFirstSidebar,
                onOpenPerformancePage: this.onOpenPerformancePage,
                onClosePerformancePage: this.onClosePerformancePage,
                onCloseInformation: this.onCloseInformation,
                onOpenInformation: this.onOpenInformation,
                activeItemIndex: activeItemIndex
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasOpenInformationAndDetails
}

export default hasOpenInformationAndDetails